"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFaceSizeAndAngle = void 0;
const face_dimensions_1 = require("./face-dimensions");
/**
 * Given a FaceRead record, calculate the size of the face image in pixels and the angle of the die
 * by inspecting the underlines and overlines.
 *
 * @param faceRead
 *
 * @returns undefined if there is no underline or overline in the FaceRead record
 */
const getFaceSizeAndAngle = (faceRead) => {
    const { underline, overline } = faceRead;
    const undoverlines = [underline, overline].filter(u => u != null);
    if (undoverlines.length == 0) {
        return undefined;
    }
    const lineLengths = undoverlines.map(({ line }) => Math.sqrt(Math.pow(line.end.x - line.start.x, 2) + Math.pow(line.end.y - line.start.y, 2)));
    const anglesInRadians = undoverlines.map(({ line }) => Math.atan2(line.end.y - line.start.y, line.end.x - line.start.x));
    const undoverlineLength = lineLengths.reduce((r, lineLength) => r + lineLength, 0) / lineLengths.length;
    const faceSizeInPixels = undoverlineLength / face_dimensions_1.FaceDimensionsFractional.undoverlineLength;
    const [angleInRadians0, angleInRadians1] = anglesInRadians;
    const angleInRadians = (angleInRadians1 == null || Math.abs(angleInRadians0 - angleInRadians1) > Math.PI) ?
        angleInRadians0 :
        (angleInRadians0 + angleInRadians1) / 2;
    return { faceSizeInPixels, angleInRadians };
};
exports.getFaceSizeAndAngle = getFaceSizeAndAngle;
//# sourceMappingURL=get-face-size-and-angle.js.map